import { render, staticRenderFns } from "./AddFilesIcon.vue?vue&type=template&id=01f46589&scoped=true"
import script from "./AddFilesIcon.vue?vue&type=script&lang=js"
export * from "./AddFilesIcon.vue?vue&type=script&lang=js"
import style0 from "./AddFilesIcon.vue?vue&type=style&index=0&id=01f46589&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f46589",
  null
  
)

export default component.exports